// import CenterPlayerNameBg from "../../assets/svgs/gameplay/CenterPlayerNameBg";
// import LeftPlayerNameBg from "../../assets/svgs/gameplay/LeftPlayerNameBg";
// import { getHeightCorrectedForIphone6, getWidth } from "../../utils/relativeSizes"
// import { BOARD_TYPE, DICE_BG_ALIGNMENT, IBoardConfig, PLAYER_NUMBER } from "./types";
// import yellow56 from "../../assets/lottie/yellow_56.json"
// import { COLOR_B5FFD4, COLOR_CFEEFF, COLOR_FFC0C0, COLOR_FFECC9 } from "../../assets/colors";
// import { GAMEPLAY_ANIMATION_IMAGES, GAMEPLAY_HYBRID_IMAGES } from "../../assets";
import { GAMEPLAY_HYBRID_IMAGES } from "../../assets/images";
import { getHeightCorrectedForIphone6, getWidth } from "../../utils/relativeSizes"
import { BOARD_TYPE, DICE_BG_ALIGNMENT, DICE_NUMBER, IBoardConfig, ILudoboardState, PLAYER_NUMBER } from "../../pages/GamePlay/types";
import { COLOR_B5FFD4, COLOR_CFEEFF, COLOR_FFC0C0, COLOR_FFECC9 } from "../../assets/colors";


// export const TWO_PLAYER_CONFIG: IBoardConfig = {
//   PLAYER_UI_CONFIG: {
//     [PLAYER_NUMBER.ONE]: {
//       containerStyle: {
//         transform: [{ translateX: getWidth(-121.3) }, { translateY: getHeightCorrectedForIphone6(162) }]
//       },
//       labelWrapperStyle: { transform: [{ translateX: getWidth(-14.5) }, { translateY: getHeightCorrectedForIphone6(7) }] },
//       infoIconWrapperStyle: { transform: [{ translateX: getWidth(48) }, { translateY: 0 }] },
//       ppWrapperStyle: {
//         transform: [{ translateX: getWidth(-14) }, { translateY: getHeightCorrectedForIphone6(50) }]
//       },
//       diceWrapperStyle: {
//         transform: [{ translateX: getWidth(53) }, { translateY: getHeightCorrectedForIphone6(50) }]
//       },
//       skipWrapperStyle: {
//         transform: [{ translateX: getWidth(48) }, { translateY: getHeightCorrectedForIphone6(-67) }]
//       },
//       coinStartLocation: {
//         translateX: getWidth(-14),
//         translateY: getHeightCorrectedForIphone6(50)
//       },
//       coinCenterLocation: {
//         translateX: getWidth(121.3),
//         translateY: getHeightCorrectedForIphone6(-187)
//       },
//       coinEndLocation: {
//         translateX: getWidth(121.3),
//         translateY: getHeightCorrectedForIphone6(-592)
//       },
//       moveStrBgStyle: { transform: [{ translateX: getWidth(-14) }, { translateY: getHeightCorrectedForIphone6(83) }] },
//       skipUpsideDown: false,
//       PlayerNameBg: LeftPlayerNameBg,
//       diceAlign: DICE_BG_ALIGNMENT.RIGHT,
//       defaultDiceImage: GAMEPLAY_HYBRID_IMAGES.dice_default
//     },
//     [PLAYER_NUMBER.TWO]: {
//       containerStyle: {
//         transform: [{ translateX: 0 }, { translateY: getHeightCorrectedForIphone6(-273) }]
//       },
//       labelWrapperStyle: { transform: [{ translateX: getWidth(-14.5) }, { translateY: getHeightCorrectedForIphone6(7) }] },
//       infoIconWrapperStyle: { transform: [{ translateX: getWidth(48) }, { translateY: 0 }] },
//       ppWrapperStyle: {
//         transform: [{ translateX: getWidth(-40) }, { translateY: getHeightCorrectedForIphone6(50) }]
//       },
//       diceWrapperStyle: {
//         transform: [{ translateX: getWidth(27) }, { translateY: getHeightCorrectedForIphone6(50) }]
//       },
//       skipWrapperStyle: {
//         transform: [{ translateX: getWidth(48) }, { translateY: getHeightCorrectedForIphone6(64) }]
//       },
//       coinStartLocation: {
//         translateX: getWidth(-35),
//         translateY: getHeightCorrectedForIphone6(50)
//       },
//       coinCenterLocation: {
//         translateX: 0,
//         translateY: getHeightCorrectedForIphone6(248)
//       },
//       coinEndLocation: {
//         translateX: 0,
//         translateY: getHeightCorrectedForIphone6(-163)
//       },
//       moveStrBgStyle: { transform: [{ translateX: getWidth(-35) }, { translateY: getHeightCorrectedForIphone6(83) }] },
//       skipUpsideDown: true,
//       PlayerNameBg: CenterPlayerNameBg,
//       diceAlign: DICE_BG_ALIGNMENT.RIGHT,
//       defaultDiceImage: GAMEPLAY_HYBRID_IMAGES.dice_default
//     },
//   },
//   OUTER_PATH_LENGTH: 52,
//   PATH_FINAL_INDEX: 56,
//   HOME_PRIZE: 56,
//   // homePos + 1 + homePrize (calc score as 0 indexed array but on home add 1 to make it 1 indexed array)
//   HOME_KUKARI_SCORE: 112,
//   SAFE_POSITIONS: [0, 8, 13, 21, 26, 34, 39, 47],
//   POSITIONS_BEFORE_LONG_STEP: [],
//   HOME_LOTTIE_FILE: {
//     [PLAYER_NUMBER.ONE]: {yellow56}
//   },
//   HOME_LOTTIE_FILE_HI: {
//     [PLAYER_NUMBER.ONE]: {yellow56}
//   },
//   OTHER_PLAYER_HOME_PNG: {
//     [PLAYER_NUMBER.TWO]: GAMEPLAY_ANIMATION_IMAGES.blue_56,
//     // [PLAYER_NUMBER.THREE]: GAMEPLAY_ANIMATION_IMAGES.red_56,
//     // [PLAYER_NUMBER.FOUR]: GAMEPLAY_ANIMATION_IMAGES.green_56
//   },
//   START_POSITIONS: {
//     [PLAYER_NUMBER.ONE]: 0,
//     [PLAYER_NUMBER.TWO]: 13,
//     [PLAYER_NUMBER.THREE]: 26,
//     [PLAYER_NUMBER.FOUR]: 39
//   },
//   KUKARI_IMAGE: {
//     [PLAYER_NUMBER.ONE]: GAMEPLAY_ANIMATION_IMAGES.figurine_2_4__yellow,
//     [PLAYER_NUMBER.TWO]: GAMEPLAY_ANIMATION_IMAGES.figurine_2_4__blue,
//     [PLAYER_NUMBER.THREE]: GAMEPLAY_ANIMATION_IMAGES.figurine_2_4__red,
//     [PLAYER_NUMBER.FOUR]: GAMEPLAY_ANIMATION_IMAGES.figurine_2_4__green
//   },
//   DESTINY_IMAGE: {
//     [PLAYER_NUMBER.ONE]: GAMEPLAY_HYBRID_IMAGES.destinyYellow,
//     [PLAYER_NUMBER.TWO]: GAMEPLAY_HYBRID_IMAGES.destinyRed,
//     [PLAYER_NUMBER.THREE]: GAMEPLAY_HYBRID_IMAGES.destinyGreen
//   },
//   SMOKE_IMAGE: {
//     [PLAYER_NUMBER.ONE]: GAMEPLAY_ANIMATION_IMAGES.smokeYellow,
//     [PLAYER_NUMBER.TWO]: GAMEPLAY_ANIMATION_IMAGES.smokeRed,
//     [PLAYER_NUMBER.THREE]: GAMEPLAY_ANIMATION_IMAGES.smokeGreen
//   },
//   GLOW_IMAGE: {
//     [PLAYER_NUMBER.ONE]: GAMEPLAY_ANIMATION_IMAGES.glowYellow,
//     [PLAYER_NUMBER.TWO]: GAMEPLAY_ANIMATION_IMAGES.glowRed,
//     [PLAYER_NUMBER.THREE]: GAMEPLAY_ANIMATION_IMAGES.glowGreen
//   },
//   COLORED_PATH_COLOR: {
//     [PLAYER_NUMBER.ONE]: COLOR_FFECC9,
//     [PLAYER_NUMBER.TWO]: COLOR_CFEEFF,
//     [PLAYER_NUMBER.THREE]: COLOR_FFC0C0,
//     [PLAYER_NUMBER.FOUR]: COLOR_B5FFD4
//   },
//   COMMON_BOXES: [
//     { translateX: getWidth(-23.5), translateY: getWidth(138.1), zIndex: 55, direction: '0deg' }, // 0 - yellow payer start
//     { translateX: getWidth(-23.5), translateY: getWidth(115.2), zIndex: 54, direction: '0deg' }, // 1
//     { translateX: getWidth(-23.5), translateY: getWidth(92.2), zIndex: 53, direction: '0deg' }, // 2
//     { translateX: getWidth(-23.5), translateY: getWidth(69.3), zIndex: 52, direction: '0deg' }, // 3
//     { translateX: getWidth(-23.5), translateY: getWidth(46.3), zIndex: 51, direction: '0deg' }, // 4

//     { translateX: getWidth(-46), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 5
//     { translateX: getWidth(-69), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 6
//     { translateX: getWidth(-92), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 7
//     { translateX: getWidth(-114.7), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 8 - save
//     { translateX: getWidth(-138), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 9
//     { translateX: getWidth(-160.7), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '0deg' }, // 10

//     { translateX: getWidth(-160.7), translateY: getWidth(0.15), rotate: '90deg', zIndex: 41, direction: '0deg' }, // 11

//     { translateX: getWidth(-160.7), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 12
//     { translateX: getWidth(-137.7), translateY: getWidth(-23.2), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 13 - blue player start
//     { translateX: getWidth(-115), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 14
//     { translateX: getWidth(-92), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 15
//     { translateX: getWidth(-69), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 16
//     { translateX: getWidth(-46), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 17

//     { translateX: getWidth(-23.5), translateY: getWidth(-45.4), zIndex: 56 }, // 18
//     { translateX: getWidth(-23.5), translateY: getWidth(-68.4), zIndex: 55 }, // 19
//     { translateX: getWidth(-23.5), translateY: getWidth(-91.4), zIndex: 54 }, // 20
//     { translateX: getWidth(-23.5), translateY: getWidth(-114.3), zIndex: 53 }, // 21 - save
//     { translateX: getWidth(-23.5), translateY: getWidth(-137.3), zIndex: 52 }, // 22
//     { translateX: getWidth(-23.5), translateY: getWidth(-160.2), zIndex: 51, direction: '90deg' }, // 23

//     { translateX: getWidth(0), translateY: getWidth(-160.1), zIndex: 41, direction: '90deg' }, // 24

//     { translateX: getWidth(23.5), translateY: getWidth(-160.2), zIndex: 31, direction: '180deg' }, // 25
//     { translateX: getWidth(23.5), translateY: getWidth(-137.3), zIndex: 32, direction: '180deg' }, // 26 - red player start
//     { translateX: getWidth(23.5), translateY: getWidth(-114.3), zIndex: 33, direction: '180deg' }, // 27
//     { translateX: getWidth(23.5), translateY: getWidth(-91.4), zIndex: 34, direction: '180deg' }, // 28
//     { translateX: getWidth(23.5), translateY: getWidth(-68.4), zIndex: 35, direction: '180deg' }, // 29
//     { translateX: getWidth(23.5), translateY: getWidth(-45.4), zIndex: 36, direction: '180deg' }, // 30

//     { translateX: getWidth(45.4), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 31
//     { translateX: getWidth(68.3), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 32
//     { translateX: getWidth(91.2), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 33
//     { translateX: getWidth(114.2), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 34 - save
//     { translateX: getWidth(137.2), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 35
//     { translateX: getWidth(160.2), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '180deg' }, // 36

//     { translateX: getWidth(160.2), translateY: getWidth(0.1), rotate: '90deg', zIndex: 41, direction: '180deg' }, // 37

//     { translateX: getWidth(160.2), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 38
//     { translateX: getWidth(137.2), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 39 - green player start
//     { translateX: getWidth(114.2), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 40
//     { translateX: getWidth(91.2), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 41
//     { translateX: getWidth(68.3), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 42
//     { translateX: getWidth(45.4), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 43

//     { translateX: getWidth(23.5), translateY: getWidth(46.3), zIndex: 31, direction: '180deg' }, // 44
//     { translateX: getWidth(23.5), translateY: getWidth(69.3), zIndex: 32, direction: '180deg' }, // 45
//     { translateX: getWidth(23.5), translateY: getWidth(92.2), zIndex: 33, direction: '180deg' }, // 46
//     { translateX: getWidth(23.5), translateY: getWidth(115.2), zIndex: 34, direction: '180deg' }, // 47 - save
//     { translateX: getWidth(23.5), translateY: getWidth(138.1), zIndex: 35, direction: '180deg' }, // 48
//     { translateX: getWidth(23.5), translateY: getWidth(161.4), zIndex: 36, direction: '-90deg' }, // 49

//     { translateX: 0, translateY: getWidth(161.4), zIndex: 46, direction: '-90deg' }, // 50

//     { translateX: getWidth(-23.5), translateY: getWidth(161.4), zIndex: 56, direction: '0deg' } // 51
//   ],
//   HOME_BOXES: {
//     [PLAYER_NUMBER.ONE]: [
//       { translateX: getWidth(-0.5), translateY: getWidth(138.1), zIndex: 45, direction: '0deg' },
//       { translateX: getWidth(-0.5), translateY: getWidth(115.2), zIndex: 44, direction: '0deg' },
//       { translateX: getWidth(-0.5), translateY: getWidth(92.2), zIndex: 43, direction: '0deg' },
//       { translateX: getWidth(-0.5), translateY: getWidth(69.3), zIndex: 42, direction: '0deg' },
//       { translateX: getWidth(-0.5), translateY: getWidth(46.3), zIndex: 41, direction: '0deg' }
//     ],
//     [PLAYER_NUMBER.TWO]: [
//       { translateX: getWidth(-138), translateY: getWidth(0), zIndex: 41 },
//       { translateX: getWidth(-115), translateY: getWidth(0), zIndex: 41 },
//       { translateX: getWidth(-92), translateY: getWidth(0), zIndex: 41 },
//       { translateX: getWidth(-69), translateY: getWidth(0), zIndex: 41 },
//       { translateX: getWidth(-46), translateY: getWidth(0), zIndex: 41 }
//     ],
//     [PLAYER_NUMBER.THREE]: [
//       { translateX: getWidth(0), translateY: getWidth(-137.3), zIndex: 41 },
//       { translateX: getWidth(0), translateY: getWidth(-114.3), zIndex: 42 },
//       { translateX: getWidth(0), translateY: getWidth(-91.4), zIndex: 43 },
//       { translateX: getWidth(0), translateY: getWidth(-68.4), zIndex: 44 },
//       { translateX: getWidth(0), translateY: getWidth(-45.4), zIndex: 45 }
//     ],
//     [PLAYER_NUMBER.FOUR]: [
//       { translateX: getWidth(137.2), translateY: getWidth(0), zIndex: 41 },
//       { translateX: getWidth(114.2), translateY: getWidth(0), zIndex: 41 },
//       { translateX: getWidth(91.2), translateY: getWidth(0), zIndex: 41 },
//       { translateX: getWidth(68.3), translateY: getWidth(0), zIndex: 41 },
//       { translateX: getWidth(45.4), translateY: getWidth(0), zIndex: 41 }
//     ]
//   },
//   FINAL_BOXES: {
//     [PLAYER_NUMBER.ONE]: [
//       { translateX: 0, translateY: getWidth(13.5) },
//       { translateX: -getWidth(12), translateY: getWidth(25) },
//       { translateX: 0, translateY: getWidth(25) },
//       { translateX: getWidth(12), translateY: getWidth(25) }
//     ],
//     [PLAYER_NUMBER.TWO]: [
//       { translateX: -getWidth(13.5), translateY: 0 },
//       { translateX: -getWidth(25), translateY: getWidth(12) },
//       { translateX: -getWidth(25), translateY: 0 },
//       { translateX: -getWidth(25), translateY: -getWidth(12) }
//     ],
//     [PLAYER_NUMBER.THREE]: [
//       { translateX: 0, translateY: -getWidth(13.5) },
//       { translateX: getWidth(12), translateY: -getWidth(25) },
//       { translateX: 0, translateY: -getWidth(25) },
//       { translateX: -getWidth(12), translateY: -getWidth(25) }
//     ],
//     [PLAYER_NUMBER.FOUR]: [
//       { translateX: getWidth(13.5), translateY: 0 },
//       { translateX: getWidth(25), translateY: -getWidth(12) },
//       { translateX: getWidth(25), translateY: 0 },
//       { translateX: getWidth(25), translateY: getWidth(12) }
//     ]
//   }
// }


interface Box {
  translateX: ReturnType<typeof getWidth>;
  translateY: ReturnType<typeof getWidth>;
  zIndex: number;
  rotate?: string;
  direction?: string;
}

export const OUTER_PATH_LENGTH = 52
export const PATH_FINAL_INDEX = 56
export const HOME_PRIZE = 56
export const TOKEN_MOVE_STEP_TIME = 170
export const TOKEN_MOVE_LONG_STEP_TIME = 230
export const TOKEN_MOVE_SCALE_TIME = 80
export const TOKEN_MOVE_LONG_SCALE_TIME = 110
export const TOKEN_KILL_STEP_TIME = 30

export const TWO_PLAYER_CONFIG: IBoardConfig = {
  PLAYER_UI_CONFIG: {
    [PLAYER_NUMBER.ONE]: {
      containerStyle: {
        transform: [{ translateX: getWidth(-121.3) }, { translateY: getHeightCorrectedForIphone6(162) }]
      },
      labelWrapperStyle: { transform: [{ translateX: getWidth(-14.5) }, { translateY: getHeightCorrectedForIphone6(7) }] },
      infoIconWrapperStyle: { transform: [{ translateX: getWidth(48) }, { translateY: 0 }] },
      ppWrapperStyle: {
        transform: [{ translateX: getWidth(-14) }, { translateY: getHeightCorrectedForIphone6(50) }]
      },
      diceWrapperStyle: {
        transform: [{ translateX: getWidth(53) }, { translateY: getHeightCorrectedForIphone6(50) }]
      },
      skipWrapperStyle: {
        transform: [{ translateX: getWidth(48) }, { translateY: getHeightCorrectedForIphone6(-67) }]
      },
      coinStartLocation: {
        translateX: getWidth(-14),
        translateY: getHeightCorrectedForIphone6(50)
      },
      coinCenterLocation: {
        translateX: getWidth(121.3),
        translateY: getHeightCorrectedForIphone6(-187)
      },
      coinEndLocation: {
        translateX: getWidth(121.3),
        translateY: getHeightCorrectedForIphone6(-592)
      },
      moveStrBgStyle: { transform: [{ translateX: getWidth(-14) }, { translateY: getHeightCorrectedForIphone6(83) }] },
      skipUpsideDown: false,
      // PlayerNameBg: LeftPlayerNameBg,
      diceAlign: DICE_BG_ALIGNMENT.RIGHT,
      defaultDiceImage: GAMEPLAY_HYBRID_IMAGES.dice_default
    },
    [PLAYER_NUMBER.TWO]: {
      containerStyle: {
        transform: [{ translateX: 0 }, { translateY: getHeightCorrectedForIphone6(-273) }]
      },
      labelWrapperStyle: { transform: [{ translateX: getWidth(-14.5) }, { translateY: getHeightCorrectedForIphone6(7) }] },
      infoIconWrapperStyle: { transform: [{ translateX: getWidth(48) }, { translateY: 0 }] },
      ppWrapperStyle: {
        transform: [{ translateX: getWidth(-40) }, { translateY: getHeightCorrectedForIphone6(50) }]
      },
      diceWrapperStyle: {
        transform: [{ translateX: getWidth(27) }, { translateY: getHeightCorrectedForIphone6(50) }]
      },
      skipWrapperStyle: {
        transform: [{ translateX: getWidth(48) }, { translateY: getHeightCorrectedForIphone6(64) }]
      },
      coinStartLocation: {
        translateX: getWidth(-35),
        translateY: getHeightCorrectedForIphone6(50)
      },
      coinCenterLocation: {
        translateX: 0,
        translateY: getHeightCorrectedForIphone6(248)
      },
      coinEndLocation: {
        translateX: 0,
        translateY: getHeightCorrectedForIphone6(-163)
      },
      moveStrBgStyle: { transform: [{ translateX: getWidth(-35) }, { translateY: getHeightCorrectedForIphone6(83) }] },
      skipUpsideDown: true,
      // PlayerNameBg: CenterPlayerNameBg,
      diceAlign: DICE_BG_ALIGNMENT.RIGHT,
      defaultDiceImage: GAMEPLAY_HYBRID_IMAGES.dice_default
    },
    [PLAYER_NUMBER.THREE]: {
      containerStyle: {
        transform: [{ translateX: getWidth(121.3) }, { translateY: getHeightCorrectedForIphone6(162) }]
      },
      labelWrapperStyle: { transform: [{ translateX: getWidth(14.5) }, { translateY: getHeightCorrectedForIphone6(7) }] },
      infoIconWrapperStyle: { transform: [{ translateX: getWidth(-48) }, { translateY: 0 }] },
      ppWrapperStyle: {
        transform: [{ translateX: getWidth(14) }, { translateY: getHeightCorrectedForIphone6(50) }]
      },
      diceWrapperStyle: {
        transform: [{ translateX: getWidth(-53) }, { translateY: getHeightCorrectedForIphone6(50) }]
      },
      moveStrBgStyle: { transform: [{ translateX: getWidth(14) }, { translateY: getHeightCorrectedForIphone6(83) }] },
      skipWrapperStyle: {
        transform: [{ translateX: getWidth(-48) }, { translateY: getHeightCorrectedForIphone6(-67) }]
      },
      coinStartLocation: {
        translateX: getWidth(14),
        translateY: getHeightCorrectedForIphone6(50)
      },
      coinCenterLocation: {
        translateX: getWidth(-121.3),
        translateY: getHeightCorrectedForIphone6(-187)
      },
      coinEndLocation: {
        translateX: getWidth(-121.3),
        translateY: getHeightCorrectedForIphone6(-592)
      },
      skipUpsideDown: false,
      // PlayerNameBg: RightPlayerNameBg,
      diceAlign: DICE_BG_ALIGNMENT.LEFT,
      defaultDiceImage: GAMEPLAY_HYBRID_IMAGES.dice_default
    },
    [PLAYER_NUMBER.FOUR]: {
      containerStyle: {
        transform: [{ translateX: 0 }, { translateY: getHeightCorrectedForIphone6(-273) }]
      },
      labelWrapperStyle: { transform: [{ translateX: getWidth(-14.5) }, { translateY: getHeightCorrectedForIphone6(7) }] },
      infoIconWrapperStyle: { transform: [{ translateX: getWidth(48) }, { translateY: 0 }] },
      ppWrapperStyle: {
        transform: [{ translateX: getWidth(-40) }, { translateY: getHeightCorrectedForIphone6(50) }]
      },
      diceWrapperStyle: {
        transform: [{ translateX: getWidth(27) }, { translateY: getHeightCorrectedForIphone6(50) }]
      },
      skipWrapperStyle: {
        transform: [{ translateX: getWidth(48) }, { translateY: getHeightCorrectedForIphone6(64) }]
      },
      coinStartLocation: {
        translateX: getWidth(-35),
        translateY: getHeightCorrectedForIphone6(50)
      },
      coinCenterLocation: {
        translateX: 0,
        translateY: getHeightCorrectedForIphone6(248)
      },
      coinEndLocation: {
        translateX: 0,
        translateY: getHeightCorrectedForIphone6(-163)
      },
      moveStrBgStyle: { transform: [{ translateX: getWidth(-35) }, { translateY: getHeightCorrectedForIphone6(83) }] },
      skipUpsideDown: true,
      // PlayerNameBg: CenterPlayerNameBg,
      diceAlign: DICE_BG_ALIGNMENT.RIGHT,
      defaultDiceImage: GAMEPLAY_HYBRID_IMAGES.dice_default
    }
  },
  OUTER_PATH_LENGTH: 52,
  PATH_FINAL_INDEX: 56,
  HOME_PRIZE: 56,
  // homePos + 1 + homePrize (calc score as 0 indexed array but on home add 1 to make it 1 indexed array)
  HOME_KUKARI_SCORE: 112,
  SAFE_POSITIONS: [0, 8, 13, 21, 26, 34, 39, 47],
  POSITIONS_BEFORE_LONG_STEP: [],
  // HOME_LOTTIE_FILE: {
  //   [PLAYER_NUMBER.ONE]: require('assets/lottie/yellow_56.json') as AnimationObject
  // },
  // HOME_LOTTIE_FILE_HI: {
  //   [PLAYER_NUMBER.ONE]: require('assets/lottie/yellow_56_hi.json') as AnimationObject
  // },
  // OTHER_PLAYER_HOME_PNG: {
  //   [PLAYER_NUMBER.TWO]: GAMEPLAY_ANIMATION_IMAGES.blue_56,
  //   [PLAYER_NUMBER.THREE]: GAMEPLAY_ANIMATION_IMAGES.red_56,
  //   [PLAYER_NUMBER.FOUR]: GAMEPLAY_ANIMATION_IMAGES.green_56
  // },
  START_POSITIONS: {
    [PLAYER_NUMBER.ONE]: 0,
    [PLAYER_NUMBER.TWO]: 13,
    [PLAYER_NUMBER.THREE]: 26,
    [PLAYER_NUMBER.FOUR]: 39
  },
  KUKARI_IMAGE: {
    [PLAYER_NUMBER.ONE]: require('../../assets/images/gameplay/figurine_2_4_player/yellow.png') as string,
    [PLAYER_NUMBER.TWO]: require('../../assets/images/gameplay/figurine_2_4_player/blue.png') as string,
    [PLAYER_NUMBER.THREE]: require('../../assets/images/gameplay/figurine_2_4_player/red.png') as string,
    [PLAYER_NUMBER.FOUR]: require('../../assets/images/gameplay/figurine_2_4_player/green.png') as string,
  },
  DESTINY_IMAGE: {
    [PLAYER_NUMBER.ONE]: GAMEPLAY_HYBRID_IMAGES.destinyYellow,
    [PLAYER_NUMBER.TWO]: GAMEPLAY_HYBRID_IMAGES.destinyRed,
    [PLAYER_NUMBER.THREE]: GAMEPLAY_HYBRID_IMAGES.destinyGreen
  },
  SMOKE_IMAGE: {
    [PLAYER_NUMBER.ONE]: require('../../assets/images/gameplay/smoke/yellow.png') as string,
    [PLAYER_NUMBER.TWO]: require('../../assets/images/gameplay/smoke/red.png') as string,
    [PLAYER_NUMBER.THREE]: require('../../assets/images/gameplay/smoke/green.png') as string,
  },
  GLOW_IMAGE: {
    [PLAYER_NUMBER.ONE]: require('../../assets/images/gameplay/movingKukariGlow/yellow.png') as string,
    [PLAYER_NUMBER.TWO]: require('../../assets/images/gameplay/movingKukariGlow/red.png') as string,
    [PLAYER_NUMBER.THREE]: require('../../assets/images/gameplay/movingKukariGlow/green.png') as string,
  },
  COLORED_PATH_COLOR: {
    [PLAYER_NUMBER.ONE]: COLOR_FFECC9,
    [PLAYER_NUMBER.TWO]: COLOR_CFEEFF,
    [PLAYER_NUMBER.THREE]: COLOR_FFC0C0,
    [PLAYER_NUMBER.FOUR]: COLOR_B5FFD4,
  },
  COMMON_BOXES: [
    { translateX: getWidth(-23.5), translateY: getWidth(138.1), zIndex: 55, direction: '0deg' }, // 0 - yellow payer start
    { translateX: getWidth(-23.5), translateY: getWidth(115.2), zIndex: 54, direction: '0deg' }, // 1
    { translateX: getWidth(-23.5), translateY: getWidth(92.2), zIndex: 53, direction: '0deg' }, // 2
    { translateX: getWidth(-23.5), translateY: getWidth(69.3), zIndex: 52, direction: '0deg' }, // 3
    { translateX: getWidth(-23.5), translateY: getWidth(46.3), zIndex: 51, direction: '0deg' }, // 4

    { translateX: getWidth(-46), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 5
    { translateX: getWidth(-69), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 6
    { translateX: getWidth(-92), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 7
    { translateX: getWidth(-114.7), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 8 - save
    { translateX: getWidth(-138), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 9
    { translateX: getWidth(-160.7), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '0deg' }, // 10

    { translateX: getWidth(-160.7), translateY: getWidth(0.15), rotate: '90deg', zIndex: 41, direction: '0deg' }, // 11

    { translateX: getWidth(-160.7), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 12
    { translateX: getWidth(-137.7), translateY: getWidth(-23.2), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 13 - blue player start
    { translateX: getWidth(-115), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 14
    { translateX: getWidth(-92), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 15
    { translateX: getWidth(-69), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 16
    { translateX: getWidth(-46), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 17

    { translateX: getWidth(-23.5), translateY: getWidth(-45.4), zIndex: 56 }, // 18
    { translateX: getWidth(-23.5), translateY: getWidth(-68.4), zIndex: 55 }, // 19
    { translateX: getWidth(-23.5), translateY: getWidth(-91.4), zIndex: 54 }, // 20
    { translateX: getWidth(-23.5), translateY: getWidth(-114.3), zIndex: 53 }, // 21 - save
    { translateX: getWidth(-23.5), translateY: getWidth(-137.3), zIndex: 52 }, // 22
    { translateX: getWidth(-23.5), translateY: getWidth(-160.2), zIndex: 51, direction: '90deg' }, // 23

    { translateX: getWidth(0), translateY: getWidth(-160.1), zIndex: 41, direction: '90deg' }, // 24

    { translateX: getWidth(23.5), translateY: getWidth(-160.2), zIndex: 31, direction: '180deg' }, // 25
    { translateX: getWidth(23.5), translateY: getWidth(-137.3), zIndex: 32, direction: '180deg' }, // 26 - red player start
    { translateX: getWidth(23.5), translateY: getWidth(-114.3), zIndex: 33, direction: '180deg' }, // 27
    { translateX: getWidth(23.5), translateY: getWidth(-91.4), zIndex: 34, direction: '180deg' }, // 28
    { translateX: getWidth(23.5), translateY: getWidth(-68.4), zIndex: 35, direction: '180deg' }, // 29
    { translateX: getWidth(23.5), translateY: getWidth(-45.4), zIndex: 36, direction: '180deg' }, // 30

    { translateX: getWidth(45.4), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 31
    { translateX: getWidth(68.3), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 32
    { translateX: getWidth(91.2), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 33
    { translateX: getWidth(114.2), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 34 - save
    { translateX: getWidth(137.2), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 35
    { translateX: getWidth(160.2), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '180deg' }, // 36

    { translateX: getWidth(160.2), translateY: getWidth(0.1), rotate: '90deg', zIndex: 41, direction: '180deg' }, // 37

    { translateX: getWidth(160.2), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 38
    { translateX: getWidth(137.2), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 39 - green player start
    { translateX: getWidth(114.2), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 40
    { translateX: getWidth(91.2), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 41
    { translateX: getWidth(68.3), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 42
    { translateX: getWidth(45.4), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 43

    { translateX: getWidth(23.5), translateY: getWidth(46.3), zIndex: 31, direction: '180deg' }, // 44
    { translateX: getWidth(23.5), translateY: getWidth(69.3), zIndex: 32, direction: '180deg' }, // 45
    { translateX: getWidth(23.5), translateY: getWidth(92.2), zIndex: 33, direction: '180deg' }, // 46
    { translateX: getWidth(23.5), translateY: getWidth(115.2), zIndex: 34, direction: '180deg' }, // 47 - save
    { translateX: getWidth(23.5), translateY: getWidth(138.1), zIndex: 35, direction: '180deg' }, // 48
    { translateX: getWidth(23.5), translateY: getWidth(161.4), zIndex: 36, direction: '-90deg' }, // 49

    { translateX: 0, translateY: getWidth(161.4), zIndex: 46, direction: '-90deg' }, // 50

    { translateX: getWidth(-23.5), translateY: getWidth(161.4), zIndex: 56, direction: '0deg' } // 51
  ],
  HOME_BOXES: {
    [PLAYER_NUMBER.ONE]: [
      { translateX: getWidth(-0.5), translateY: getWidth(138.1), zIndex: 45, direction: '0deg' },
      { translateX: getWidth(-0.5), translateY: getWidth(115.2), zIndex: 44, direction: '0deg' },
      { translateX: getWidth(-0.5), translateY: getWidth(92.2), zIndex: 43, direction: '0deg' },
      { translateX: getWidth(-0.5), translateY: getWidth(69.3), zIndex: 42, direction: '0deg' },
      { translateX: getWidth(-0.5), translateY: getWidth(46.3), zIndex: 41, direction: '0deg' }
    ],
    [PLAYER_NUMBER.TWO]: [
      { translateX: getWidth(-138), translateY: getWidth(0), zIndex: 41 },
      { translateX: getWidth(-115), translateY: getWidth(0), zIndex: 41 },
      { translateX: getWidth(-92), translateY: getWidth(0), zIndex: 41 },
      { translateX: getWidth(-69), translateY: getWidth(0), zIndex: 41 },
      { translateX: getWidth(-46), translateY: getWidth(0), zIndex: 41 }
    ],
    [PLAYER_NUMBER.THREE]: [
      { translateX: getWidth(0), translateY: getWidth(-137.3), zIndex: 41 },
      { translateX: getWidth(0), translateY: getWidth(-114.3), zIndex: 42 },
      { translateX: getWidth(0), translateY: getWidth(-91.4), zIndex: 43 },
      { translateX: getWidth(0), translateY: getWidth(-68.4), zIndex: 44 },
      { translateX: getWidth(0), translateY: getWidth(-45.4), zIndex: 45 }
    ],
    [PLAYER_NUMBER.FOUR]: [
      { translateX: getWidth(137.2), translateY: getWidth(0), zIndex: 41 },
      { translateX: getWidth(114.2), translateY: getWidth(0), zIndex: 41 },
      { translateX: getWidth(91.2), translateY: getWidth(0), zIndex: 41 },
      { translateX: getWidth(68.3), translateY: getWidth(0), zIndex: 41 },
      { translateX: getWidth(45.4), translateY: getWidth(0), zIndex: 41 }
    ]
  },
  FINAL_BOXES: {
    [PLAYER_NUMBER.ONE]: [
      { translateX: 0, translateY: getWidth(13.5) },
      { translateX: -getWidth(12), translateY: getWidth(25) },
      { translateX: 0, translateY: getWidth(25) },
      { translateX: getWidth(12), translateY: getWidth(25) }
    ],
    [PLAYER_NUMBER.TWO]: [
      { translateX: -getWidth(13.5), translateY: 0 },
      { translateX: -getWidth(25), translateY: getWidth(12) },
      { translateX: -getWidth(25), translateY: 0 },
      { translateX: -getWidth(25), translateY: -getWidth(12) }
    ],
    [PLAYER_NUMBER.THREE]: [
      { translateX: 0, translateY: -getWidth(13.5) },
      { translateX: getWidth(12), translateY: -getWidth(25) },
      { translateX: 0, translateY: -getWidth(25) },
      { translateX: -getWidth(12), translateY: -getWidth(25) }
    ],
    [PLAYER_NUMBER.FOUR]: [
      { translateX: getWidth(13.5), translateY: 0 },
      { translateX: getWidth(25), translateY: -getWidth(12) },
      { translateX: getWidth(25), translateY: 0 },
      { translateX: getWidth(25), translateY: getWidth(12) }
    ]
  }
}


export const COMMON_BOXES: Box[] = [
  { translateX: getWidth(-23.5), translateY: getWidth(138.1), zIndex: 55, direction: '0deg' }, // 0 - yellow payer start
  { translateX: getWidth(-23.5), translateY: getWidth(115.2), zIndex: 54, direction: '0deg' }, // 1
  { translateX: getWidth(-23.5), translateY: getWidth(92.2), zIndex: 53, direction: '0deg' }, // 2
  { translateX: getWidth(-23.5), translateY: getWidth(69.3), zIndex: 52, direction: '0deg' }, // 3
  { translateX: getWidth(-23.5), translateY: getWidth(46.3), zIndex: 51, direction: '0deg' }, // 4

  { translateX: getWidth(-46), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 5
  { translateX: getWidth(-69), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 6
  { translateX: getWidth(-92), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 7
  { translateX: getWidth(-114.7), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 8 - save
  { translateX: getWidth(-138), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 9
  { translateX: getWidth(-160.7), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '0deg' }, // 10

  { translateX: getWidth(-160.7), translateY: getWidth(0.15), rotate: '90deg', zIndex: 41, direction: '0deg' }, // 11

  { translateX: getWidth(-160.7), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 12
  { translateX: getWidth(-137.7), translateY: getWidth(-23.2), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 13 - blue player start
  { translateX: getWidth(-115), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 14
  { translateX: getWidth(-92), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 15
  { translateX: getWidth(-69), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 16
  { translateX: getWidth(-46), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 17

  { translateX: getWidth(-23.5), translateY: getWidth(-45.4), zIndex: 56 }, // 18
  { translateX: getWidth(-23.5), translateY: getWidth(-68.4), zIndex: 55 }, // 19
  { translateX: getWidth(-23.5), translateY: getWidth(-91.4), zIndex: 54 }, // 20
  { translateX: getWidth(-23.5), translateY: getWidth(-114.3), zIndex: 53 }, // 21 - save
  { translateX: getWidth(-23.5), translateY: getWidth(-137.3), zIndex: 52 }, // 22
  { translateX: getWidth(-23.5), translateY: getWidth(-160.2), zIndex: 51, direction: '90deg' }, // 23

  { translateX: getWidth(0), translateY: getWidth(-160.1), zIndex: 41, direction: '90deg' }, // 24

  { translateX: getWidth(23.5), translateY: getWidth(-160.2), zIndex: 31, direction: '180deg' }, // 25
  { translateX: getWidth(23.5), translateY: getWidth(-137.3), zIndex: 32, direction: '180deg' }, // 26 - red player start
  { translateX: getWidth(23.5), translateY: getWidth(-114.3), zIndex: 33, direction: '180deg' }, // 27
  { translateX: getWidth(23.5), translateY: getWidth(-91.4), zIndex: 34, direction: '180deg' }, // 28
  { translateX: getWidth(23.5), translateY: getWidth(-68.4), zIndex: 35, direction: '180deg' }, // 29
  { translateX: getWidth(23.5), translateY: getWidth(-45.4), zIndex: 36, direction: '180deg' }, // 30

  { translateX: getWidth(45.4), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 31
  { translateX: getWidth(68.3), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 32
  { translateX: getWidth(91.2), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 33
  { translateX: getWidth(114.2), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 34 - save
  { translateX: getWidth(137.2), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '90deg' }, // 35
  { translateX: getWidth(160.2), translateY: getWidth(-23.4), rotate: '90deg', zIndex: 31, direction: '180deg' }, // 36

  { translateX: getWidth(160.2), translateY: getWidth(0.1), rotate: '90deg', zIndex: 41, direction: '180deg' }, // 37

  { translateX: getWidth(160.2), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 38
  { translateX: getWidth(137.2), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 39 - green player start
  { translateX: getWidth(114.2), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 40
  { translateX: getWidth(91.2), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 41
  { translateX: getWidth(68.3), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 42
  { translateX: getWidth(45.4), translateY: getWidth(23.5), rotate: '90deg', zIndex: 51, direction: '-90deg' }, // 43

  { translateX: getWidth(23.5), translateY: getWidth(46.3), zIndex: 31, direction: '180deg' }, // 44
  { translateX: getWidth(23.5), translateY: getWidth(69.3), zIndex: 32, direction: '180deg' }, // 45
  { translateX: getWidth(23.5), translateY: getWidth(92.2), zIndex: 33, direction: '180deg' }, // 46
  { translateX: getWidth(23.5), translateY: getWidth(115.2), zIndex: 34, direction: '180deg' }, // 47 - save
  { translateX: getWidth(23.5), translateY: getWidth(138.1), zIndex: 35, direction: '180deg' }, // 48
  { translateX: getWidth(23.5), translateY: getWidth(161.4), zIndex: 36, direction: '-90deg' }, // 49

  { translateX: 0, translateY: getWidth(161.4), zIndex: 46, direction: '-90deg' }, // 50

  { translateX: getWidth(-23.5), translateY: getWidth(161.4), zIndex: 56, direction: '0deg' } // 51
]


export const BOARD_CONFIG: { [key in BOARD_TYPE]?: IBoardConfig } = {
  // [BOARD_TYPE.TRIO_BOARD]: THREE_PLAYER_CONFIG,
  [BOARD_TYPE.DEFAULT_BOARD]: TWO_PLAYER_CONFIG
}

export const DICE_NUMBER_IMAGE: Record<DICE_NUMBER, string> = {
  [DICE_NUMBER.ONE]: GAMEPLAY_HYBRID_IMAGES.dice1,
  [DICE_NUMBER.TWO]: GAMEPLAY_HYBRID_IMAGES.dice2,
  [DICE_NUMBER.THREE]: GAMEPLAY_HYBRID_IMAGES.dice3,
  [DICE_NUMBER.FOUR]: GAMEPLAY_HYBRID_IMAGES.dice4,
  [DICE_NUMBER.FIVE]: GAMEPLAY_HYBRID_IMAGES.dice5,
  [DICE_NUMBER.SIX]: GAMEPLAY_HYBRID_IMAGES.dice6
}

export const DICE2P_NUMBER_IMAGE: Record<DICE_NUMBER, string> = {
  [DICE_NUMBER.ONE]: GAMEPLAY_HYBRID_IMAGES.dice2P_1,
  [DICE_NUMBER.TWO]: GAMEPLAY_HYBRID_IMAGES.dice2P_2,
  [DICE_NUMBER.THREE]: GAMEPLAY_HYBRID_IMAGES.dice2P_3,
  [DICE_NUMBER.FOUR]: GAMEPLAY_HYBRID_IMAGES.dice2P_4,
  [DICE_NUMBER.FIVE]: GAMEPLAY_HYBRID_IMAGES.dice2P_5,
  [DICE_NUMBER.SIX]: GAMEPLAY_HYBRID_IMAGES.dice2P_6
}

export const INITIAL_STATE: ILudoboardState = {
  tableInfo: {
    _id: null,
    ltid: null,
    gtiAP: null,
    prizePot: null,
    gameTimer: -1,
    pi: [],
    mySeatIndex: null,
    tst: null,
    shareCode: null,
    totalPlayers: null,
    isOpenShareModal: false,
    coinAnimation: false,
    bounceAnimation: false,
    smokeAnimation: false,
    finalMovePlayers: [],
    startGameIcon: false,
    startDice: null,
    gameStartCountdown: 0,
    leftPlayers: [],
    finishingGame: false,
    pointsAnimation: false,
    tripleSixAnimation: false,
    turnSi: null,
    timeLeft: null,
    dv: null,
    IsTtsix: null,
    payoutDistribution: {},
    entryFee: null,
    showProfileModal: false,
    showInternetIcon: false,
    internetConnectivity: '',
    showTurnTimer: false,
    smoke: null,
    homeAnimationConfig: null,
    showGameTimeNudge: false,
    showGameStartNudge: false,
    showSkipBox: false,
    showWrongTurnAlert: false,
    skipSi: null,
    currentPlayerTurnCount: 0,
    kukariMoveConfig: null,
    scoreFlyAnimationConfig: {
      [PLAYER_NUMBER.ONE]: null,
      [PLAYER_NUMBER.TWO]: null,
      [PLAYER_NUMBER.THREE]: null,
      [PLAYER_NUMBER.FOUR]: null
    },
    showTakeHomeNudge: false,
    gameTimeLimitText: null,
    ttoScreenData: null,
    skipCountForNudge: null,
    tokenCutCN: [],
    reachHomeCN: [],
    safeCN: [],
    roundNumber: null,
    isPrizepoolTooltipVisible: false,
    isTNCBSVisible: false,
    timeBankTimeLeft: 0,
    poolDistribution: [],
    quickGuide: [],
    movesLeft: 0,
    extraPointForHomeEnabled: false,
    textForGameFeed: [],
    playedTc: -1,
    score: 0,
    isTimeBankVisible: false,
    totalTimeBankTime: 60,
    showGameEndNudge: false,
    isKukariScoreVisible: false,
    isScoreRevealAnimationVisible: false,
    showExtraMoveNudge: false,
    isSkipTooltipVisible: false,
    ftcpData: {
      maxCurrentUserTurnAnimation: 0,
      maxOtherUserTurnAnimation: 0,
      isVoiceOverEnabled: false
    },
    tableStartTime: null,
    pgi: {},
    maxWinners: null
  },
  userProfile: {}
}


export const SOUND_KEYS = {
  MUSIC: require('../../assets/soundFiles/music.wav'),
  BUTTON_SOUND: require('../../assets/soundFiles/buttonSound.wav'),
  BOOT_VALUE_SELECT: require('../../assets/soundFiles/bootValueSelect.wav'),
  DAILY_BONUS_SELECT: require('../../assets/soundFiles/dailyBonusSelect.wav'),
  REACH_HOME: require('../../assets/soundFiles/reachHome.wav'),
  ROLL_DICE: require('../../assets/soundFiles/rollDice.wav'),
  SAFE_PLACE: require('../../assets/soundFiles/safePlace.wav'),
  SKIP: require('../../assets/soundFiles/skip.wav'),
  START: require('../../assets/soundFiles/start.wav'),
  TIME_UP: require('../../assets/soundFiles/timeUp.wav'),
  TIME_OUT: require('../../assets/soundFiles/timeOut.wav'),
  TOKEN_KILL: require('../../assets/soundFiles/tokenKill.wav'),
  TOKEN_MOVE: require('../../assets/soundFiles/tokenMove.wav'),
  TURN_TIMER: require('../../assets/soundFiles/turnTimer.wav'),
  USER_TURN: require('../../assets/soundFiles/userTurn.wav'),
  NOTIFICATION: require('../../assets/soundFiles/notification.wav'),
  WINNING: require('../../assets/soundFiles/winning.wav'),
  FIVE_MINUTES_KA_GAME: require('../../assets/soundFiles/5_min_game.wav'),
  SEVEN_MINUTES_KA_GAME: require('../../assets/soundFiles/7_min_game.wav'),
  EIGHT_MINUTES_KA_GAME: require('../../assets/soundFiles/8_min_game.wav'),
  TEN_MINUTES_KA_GAME: require('../../assets/soundFiles/10_min_ka_game.wav'),
  AAKHIRI_1_MINUTE_BAKI: require('../../assets/soundFiles/aakhiri_1_minute_baki.wav'),
  CHAAL_MISS_HO_GAI: require('../../assets/soundFiles/chaal_miss_ho_gai.wav'),
  DOBARA_CHAAL_MISS: require('../../assets/soundFiles/dobara_chaal_miss.wav'),
  TEESRI_CHAAL_MISS: require('../../assets/soundFiles/teesri_chaal_miss.wav'),
  EXTRA_SCORE_MILA: require('../../assets/soundFiles/extra_56_score_mila.wav'),
  TOKEN_GHAR_LE_JAAEN: require('../../assets/soundFiles/token_ghar_le_jaaen.wav'),
  ZYADA_SCORE_BANAO: require('../../assets/soundFiles/zyada_score_banao.wav'),
  HALF_TIME_SAMAPT: require('../../assets/soundFiles/half_time_samapt.wav'),
  COLLECT_COINS: require('../../assets/soundFiles/collect_coins.wav'),
  DUSRE_PLAYER_KA_TOKEN_KAAT_SKTE_HAI: require('../../assets/soundFiles/dusre_player_ka_token_kaat_skte_hai.wav'),
  TOKEN_KO_SAFE_SPOT_PR_LE_JAA_SKTE_HAI: require('../../assets/soundFiles/token_ko_safe_spot_pr_le_jaa_skte_hai.wav'),
  TOKEN_KO_GHAR_LE_JAA_SKTE_HAI: require('../../assets/soundFiles/token_ko_ghar_le_jaa_skte_hai.wav')
}

export const TST_ROUND_STARTED = 'RoundStarted'

const SHOW_ALERT = 'SHOW_ALERT'
const HIDE_ALERT = 'HIDE_ALERT'

const ALERT_TYPE = {
  SUCCESS: 'SUCCESS',
  ALERT: 'ALERT',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
  INFO: 'INFO'
}
const SHOW_LOADER = 'SHOW_LOADER'
const HIDE_LOADER = 'HIDE_LOADER'

const NETWORK_ERROR = 'Network Error'
const TIME_OUT_EXCEED = 'timeout'
const EXPONENTIAL_BACKOFF = [1, 2, 5]
const RESEND_OTP = 30
const RETRY_COUNT = 3
const RETRY_OTP = 5

export {
  SHOW_ALERT,
  HIDE_ALERT,
  ALERT_TYPE,
  SHOW_LOADER,
  HIDE_LOADER,
  NETWORK_ERROR,
  TIME_OUT_EXCEED,
  EXPONENTIAL_BACKOFF,
  RESEND_OTP,
  RETRY_OTP,
  RETRY_COUNT
}
